var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEntra(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 7.697,
    x2: 14.082,
    y1: 12.409,
    y2: 4.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#225086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0055c5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 6.363,
    x2: 6.363,
    y1: 13.413,
    y2: -2.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0294e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 9,
    x2: 9,
    y1: 15.621,
    y2: -3.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#44dbf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbf8ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 13.5,
    x2: 13.5,
    y1: 16.856,
    y2: 0.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#041642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041642",
    stopOpacity: 0.25
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m17.646 9.967-7.5-8.46a1.55 1.55 0 0 0-2.294 0L.353 9.967c-.579.654-.428 1.641.323 2.111l7.499 4.688c.5.313 1.148.313 1.648 0l7.499-4.688c.751-.469.902-1.457.323-2.111Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M10.147 1.507a1.55 1.55 0 0 0-2.294 0L.354 9.967c-.579.654-.428 1.641.323 2.111l3.126 1.954c.388.242 1.033.511 1.715.511.621 0 1.197-.18 1.676-.487l.002-.001L9 12.927l-4.364-2.728L9.11 5.152a3.05 3.05 0 0 1 2.302-1.026c.472 0 .917.107 1.314.292l-2.579-2.909Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m4.636 10.199.052.032L9 12.927l4.364-2.728h.001-.001L9 5.275z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    fillOpacity: 0.5,
    d: "M9 17c.287 0 .574-.078.824-.234l7.499-4.688c.751-.469.902-1.457.323-2.111l-7.499-8.46A1.53 1.53 0 0 0 9 1z",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntra);
export default __webpack_public_path__ + "static/media/Entra.5a21113fc5a9937c287dcd5c2b31bde4.svg";
export { ForwardRef as ReactComponent };